@if (component?.columns?.length && !(isFacet && component.showOnFacets === 'hide')) {
<div class="row-component">
    <div [class.animate-transform]="component.animate"
         [scrollAnimation]="component.animate"
         [startValue]="component.animation_start_value || 150">
        <div class="pos-relative"
             [ngClass]="component.width || ''">
            <div class="row-wrapper"
                 [ngClass]="[component?.align_vertical || '']"
                 [grid]="component?.grid_size"
                 [gridColumnGap]="component.grid_gap"
                 [gridRowGap]="component.grid_gap">
                @for (column of component?.columns; track column; let i = $index; let isLast = $last; let isFirst =
                $first) {
                <div class="column-resize-wrapper"
                     [class.m-r-0]="isLast"
                     [gridColumn]="column.size"
                     [gridColumnOffset]="column.offset">
                    <icms-outlet [name]="'Column'"
                                 [syncCd]="true"
                                 [components]="column.components">
                    </icms-outlet>
                </div>
                }
            </div>
        </div>
    </div>
</div>
}